/*
 * varieties reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';
import { VARIETIES_SET } from './constants';

type State = {
    [string]: Object
};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function (state: State = initialState, action: Action) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED: {
            const varieties = get(action, 'payload.entities.varieties', {});
            return {
                ...varieties
            };
        }
        case VARIETIES_SET:
            return {
                ...state,
                ...action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
